export default __webpack_public_path__ + "static/media/study.dd194f41.svg";